import {FC} from 'react'

type Props = {
  store: any
}

const Footer: FC<Props> = ({store}) => {
  return (
    <>
      {/* <div className='text-center card-rounded d-flex flex-column justify-content-center'>
        <span>There are other items from your order not included in this shipment.</span>
        <div className='separator border-dark my-5'></div>
      </div> */}

      <div className='flex-grow-1'>
        <div className='text-center card-rounded d-flex flex-column justify-content-center p-10'>
          <span>Thank you for shopping with us!</span>

          <h1 className='text-dark my-5'>{store.name}</h1>
          <div className='text-gray-700 fs-3  d-flex text-center justify-content-center'>
            <span className='me-1'>{store.addressLine1},</span>
            {store.addressLine2 && <span className='me-1'>{store.addressLine2},</span>}
            <span className='me-1'>
              {store.city} {store.state} {store.zipCode} {store.country}
            </span>
          </div>
          <div className='text-gray-700 fs-3 fw-bold'>{store.customerEmail}</div>
          <div className='text-gray-700 fs-3 fw-bold'>{store.domain}</div>
        </div>
      </div>
    </>
  )
}

export default Footer
